import ReactDOM from 'react-dom';

export const Portal = ({ children }) => {
  const portalDiv = document.getElementById('portal');

  return ReactDOM.createPortal(children, portalDiv);
};

export default Portal;
